export default "__VITE_ASSET__i0sCCsI9__"